import { apiGet } from 'shared/services/api/resource';
import {
  ADMIN_ARENAS,
  ADMIN_DISPUTES,
  ADMIN_MODERATION,
  ADMIN_TRANSACTIONS,
  ARENAS_BY_PLAN,
  ARENAS_BY_STATUS,
  GMV_TREND,
  MRR_TREND,
  PLATFORM_KPIS,
  PLATFORM_REVENUE_SPLIT,
  WEBHOOK_EVENTS,
  WEBHOOK_KPIS,
  WEBHOOK_SUCCESS_TREND,
} from 'modules/admin/dashboard/content';

export interface AdminDashboardData {
  platformKpis: typeof PLATFORM_KPIS;
  arenas: typeof ADMIN_ARENAS;
  transactions: typeof ADMIN_TRANSACTIONS;
  disputes: typeof ADMIN_DISPUTES;
  moderationQueue: typeof ADMIN_MODERATION;
  mrrTrend: typeof MRR_TREND;
  gmvTrend: typeof GMV_TREND;
  revenueSplit: typeof PLATFORM_REVENUE_SPLIT;
  arenasByPlan: typeof ARENAS_BY_PLAN;
  arenasByStatus: typeof ARENAS_BY_STATUS;
  webhookKpis: typeof WEBHOOK_KPIS;
  webhookSuccessTrend: typeof WEBHOOK_SUCCESS_TREND;
  webhookEvents: typeof WEBHOOK_EVENTS;
}

const MOCK_ADMIN_DASHBOARD: AdminDashboardData = {
  platformKpis: PLATFORM_KPIS,
  arenas: ADMIN_ARENAS,
  transactions: ADMIN_TRANSACTIONS,
  disputes: ADMIN_DISPUTES,
  moderationQueue: ADMIN_MODERATION,
  mrrTrend: MRR_TREND,
  gmvTrend: GMV_TREND,
  revenueSplit: PLATFORM_REVENUE_SPLIT,
  arenasByPlan: ARENAS_BY_PLAN,
  arenasByStatus: ARENAS_BY_STATUS,
  webhookKpis: WEBHOOK_KPIS,
  webhookSuccessTrend: WEBHOOK_SUCCESS_TREND,
  webhookEvents: WEBHOOK_EVENTS,
};

export function fetchAdminDashboard(): Promise<AdminDashboardData> {
  return apiGet(MOCK_ADMIN_DASHBOARD, '/admin/dashboard');
}
